








    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component({
        name: "productNotFound",
        components: {
            protectNow: () => import('@/components/ProtectNow.vue'),
        },
        mixins:[]
    })
    export default class productNotFound extends Vue {
        public created():void {
            // on componenet created
        }
        public mounted():void {
            // on componenet mounted
        }
    }
